import {MaterialData} from "./materialData";
import {OwayoKonfiPart} from "../owayoPartWithSelObs";
import {owayoUtils} from "../owayoUtils";
import {THREE} from "../resource/three";
import {arrayGetElementByNoneCaseSensitiveName} from "@k/global/arrayHelper";
import {VIEWERFEATURE} from "../debugMenu";
import {ShaderCreator} from "../shader/OwayoShader";
import globalsObject from "../globalsObject";
import DEBUG from "../DEBUG";
import axios from "axios";
import {PartPattern} from "../pattern/partPattern";
import {OwayoPartBaseClass} from "../../../vorschauviewer/src/js/owayoPartBaseClass";
import {PartForMaterial} from "../owayoJSViewerWithSelObs";
import {StringDictionary} from "../delme_globals";


interface ViewerForMaterial {
    get modelParts():StringDictionary<PartForMaterial>;
    getPatterns(partname:string):PartPattern[]
}




export class OwayoMaterial {
    protected readonly name:string;
    protected owayoViewer:ViewerForMaterial;
    protected isLoaded=false;
    protected data:MaterialData;
    protected readonly textures:any;
    protected partsWithMaterial:string[]=[];

    constructor(materialName:string, owayoViewer:ViewerForMaterial) {
        this.name = materialName;
        this.owayoViewer = owayoViewer;
        this.data = new MaterialData();
        this.textures = [];
        this.loadMaterial("/Stoffe/v2/" + owayoUtils.getCleanPartName(materialName).toLowerCase() + ".json");
    }

    public setMaterialData = (key:string, value:any)=>{
        this.data[key] = value;
        this.updateAllParts();
    }

    public setMaterialDataVec2Component = (vec2name:string, dim:"x"|"y", value:number)=>{
        this.data[vec2name][dim] = value;
        this.updateAllParts();
    }
    public textureChanged = ()=>this.onLoaded();

    public getMaterialData = (valuename?:string)=>valuename !== undefined ? this.data[valuename] : this.data;

    public addPart(part:string) {
        this.partsWithMaterial.push(part);
        if (this.isLoaded) {

            this.setMaterialToPart(part);
        }
    }

    private createTexture(textureName:string, imageDataBase64:string, textureFilter = null) {
        if (this.textures[textureName]) {
            this.textures[textureName].dispose();
            this.textures[textureName] = null;
        }

        if (imageDataBase64 === "" || imageDataBase64 === undefined) {
            return;
        }

        const image = document.createElement('img');
        const texture = new THREE.Texture(image);
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.image.src = 'data:image/png;base64,' + imageDataBase64;
        texture.needsUpdate = true;
        if(textureFilter !== null) {
            texture.minFilter = textureFilter;
            texture.magFilter = textureFilter;
        }
        this.textures[textureName] = texture;
    }

    private updateAllParts() {
        this.partsWithMaterial.forEach(p=>this.setMaterialToPart(p))
    }

    protected onLoaded() {
        this.createTexture("alphaMap", this.data.alphaMap);
        this.createTexture("specularMap", this.data.specularMap);
        this.createTexture("bumpMap", this.data.bumpMap);
        this.createTexture("normalMap", this.data.normalMap);
        this.createTexture("overlayMap", this.data.overlayMap, THREE.NearestFilter);
        this.isLoaded = true;
        this.updateAllParts();

    }

    public setMaterialToPart(partName:string) {
        const part = arrayGetElementByNoneCaseSensitiveName(this.owayoViewer.modelParts, partName) as OwayoKonfiPart;
        if (!part) {
            return;
        }

        part.alphaMap = this.textures.alphaMap;
        part.specularMap = this.textures.specularMap;
        part.bumpMap = this.textures.bumpMap;
        part.normalMap = this.textures.normalMap;
        part.innenseiteAufhellen = this.data.innenseiteAufhellen;
        part.bumpScale = this.data.bumpScale;
        part.normalScale = this.data.normalScale;
        part.schwarzAufhellenImDruckbereich = this.data.schwarzAufhellenImDruckbereich;
        part.shininess = this.data.shininess;
        part.specularMin = this.data.specularMin;
        part.specular = this.data.specular;
        if(VIEWERFEATURE.USE_DROPPABLE_FROM_STOFF) {
            part.isDroppableLegacyFromStoff = this.data.isDroppable || false;
        }
        if (this.data.overrideScale) {
            part.offsetRepeat.set(0.0, 0.0, this.data.scaleStoff.x, this.data.scaleStoff.y);
        } else {
            part.offsetRepeat && part.offsetRepeat.set(0.0, 0.0, part.partSizeCM.x / this.data.scaleStoff.x, part.partSizeCM.y / this.data.scaleStoff.y);
        }

        part.overlayMap = this.textures.overlayMap;
        part.overlayIntensity = this.data.overlayIntensity;
        part.overlayHelligkeitsSummand = this.data.overlayHelligkeitsSummand;
        part.overlayScale = this.data.overlayScale;
        part.overlayAnzeigenAufFarbenIntArray = this.data.overlayAnzeigenAufFarbenIntArray
        this.createShaders(part, this.owayoViewer.getPatterns(part.name));
        // ShaderCreator.createShaders(part, this.owayoViewer.getPatterns(part.name));
    }

    protected createShaders(part:OwayoKonfiPart|OwayoPartBaseClass, patterns:any[] = []) {
        ShaderCreator.createShaders(part, patterns);
    }

    public loadMaterial(url:string) {
        const $this = this;

        axios.get(url).then((response)=>{
            $this.data.initFromJSONData(response.data);
            $this.onLoaded();
        }).catch(()=>{
            if (globalsObject.controller && globalsObject.controller.model.getCurrentOwayoProduct().defaultMaterial !== null && globalsObject.controller.model.getCurrentOwayoProduct().defaultMaterial!== undefined) {
                const urlNeu = "/Stoffe/v2/" + owayoUtils.getCleanPartName(globalsObject.controller.model.getCurrentOwayoProduct().defaultMaterial).toLowerCase() + ".json";
                if (urlNeu !== url) {
                    $this.loadMaterial(urlNeu);
                    return;
                }
            }
            $this.data = new MaterialData();
            if(VIEWERFEATURE.USE_DROPPABLE_FROM_STOFF) {
                $this.data.isDroppable = false;
            }
            if (DEBUG) {
                console.warn('material nicht vorhanden: ' + url);
            }
            $this.onLoaded();
        })
    }
    getName = () => this.name;
}
